import { useEffect, useRef, useState } from 'react'

import config, { API_TYPES } from 'constants/api-config'

const azTokenKey = 'WPP_ALPHA_ZULU_TOKEN'

export const useAZToken = (wppToken: string) => {
  const prevWppToken = useRef<string>(wppToken)

  const [token, setToken] = useState(localStorage.getItem(azTokenKey) || '')

  const setAndSaveToken = (token: string) => {
    if (token === 'undefined' || !token) {
      localStorage.removeItem(azTokenKey)
      setToken('')
      return
    }
    setToken(token)
    localStorage.setItem(azTokenKey, token)
  }

  const fetchAZToken = async () => {
    try {
      const res = await fetch(`${config[API_TYPES.MT_API_URL]}/alpha-zulu/token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          client: 'playground-dev-fe',
        },
        body: JSON.stringify({
          token: wppToken,
        }),
      })
      const data = await res.json()
      if (!data.accessToken) {
        throw new Error('Invalid response')
      }
      setAndSaveToken(data.accessToken)
    } catch (error) {
      console.error('Error fetching token', error)
      setToken('')
      localStorage.removeItem(azTokenKey)
    }
  }

  const getAZToken = () => {
    const tmpToken = localStorage.getItem(azTokenKey) || ''
    if (!!tmpToken && tmpToken !== 'undefined') {
      setToken(tmpToken)
      if (tmpToken === 'undefined') {
        localStorage.removeItem(azTokenKey)
      }
      return
    }
    if (wppToken) {
      fetchAZToken()
    }
  }

  useEffect(() => {
    if (!token && !!wppToken) {
      getAZToken()
      prevWppToken.current = wppToken
      return
    }

    if (prevWppToken.current !== wppToken && wppToken) {
      fetchAZToken()
      prevWppToken.current = wppToken
      return
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, wppToken])

  const removeToken = () => {
    setToken('')
    localStorage.removeItem(azTokenKey)
  }

  return {
    azAccessToken: token,
    setAndSaveToken,
    removeToken,
    refreshToken: fetchAZToken,
  }
}
